<template>
    <div>
      <holiday-list></holiday-list>
    </div>
  </template>
  
  <script>
  
  export default {
  }
  </script>
  
  
  